// @ts-nocheck
/* eslint-disable */

'use client';

import { Button, Column, FrameCard, Heading, Loader, RichText, Row, Spacer, variables } from 'daskapital-ds';

// import BlockFeaturedGrid from "@/components/blocks/miewtheme/BlockFeaturedGrid";
import BlockTaxonomyGrid from '@/components/blocks/miewtheme/BlockTaxonomyGrid';
import Link from 'next/link';
import NavigationEvents from '@/components/common/NavigationEvents/NavigationEvents';
import { Suspense } from 'react';
import displayBlock from '@/lib/wordpress/blocks/displayBlock';
import { useGlobalContext } from '@/lib/globalContext';
import BlockArchiveGrid from '@/components/blocks/miewtheme/BlockArchiveGrid';

const HelpCenterPage = (post: Record<string, unknown>) => {
	const { grid, lastNews } = post;
	const state = useGlobalContext();

	return (
		<div>
			<Suspense>
				<NavigationEvents translatedURI={post?.translatedURI} acf={{ page_style: 'light' }} />
				{!!(post?.intro?.blocks as [])?.length &&
					(post?.intro?.blocks as []).map((block: BlocksProps, index: number) => {
						return displayBlock(block, index);
					})}
			</Suspense>

			<div className="pt-8 pb-8" style={{ backgroundColor: variables.colors.gray90 }}>
				<Row>
					<Column lg={1}></Column>
					<Column lg={10} className="color-white text-center">
						<Heading size="h2" tag="h1">
							{post.name}
						</Heading>
						<RichText tag="p" className="mt-4">
							{post.description}
						</RichText>
					</Column>
					<Column lg={1}></Column>
				</Row>
			</div>

			<Spacer customHeight="4rem" />

			<Row>
				<Column lg={1}></Column>
				<Column lg={10}>
					<Heading tag="span" size="h6" className="text-uppercase">{state?.dict?.helpCenter?.otherCategories}</Heading>
					<Spacer height={4} />
					<BlockTaxonomyGrid
						attrs={{
							title: "",
							component: "HelpCenterCard",
							grid: post.categories,
						}}
					/>
				</Column>
				<Column lg={1}></Column>
			</Row>

			<Spacer customHeight="4rem" />
			
			{grid?.items && (
				<>
					<Row>
						<Column lg={1}></Column>
						<Column lg={10}>
							<Heading tag="span" size="h3">{post.name}</Heading>
							<Spacer customHeight="2rem" />
							<BlockArchiveGrid attrs={{
								grid: grid,
								post_type: "help-center",
								per_page: -1,
								component: "HelpCenterCard",
								showFilters: true,
								per_line: 1,
								taxonomy: post.slug,

							}} />
						</Column>
						<Column lg={1}></Column>
					</Row>
					<Spacer customHeight="6rem" />
				</>
			)}

			<Spacer customHeight="8rem" />

			{!!(lastNews?.blocks as [])?.length &&
				(lastNews?.blocks as []).map((block: BlocksProps, index: number) => {
					return displayBlock(block, index);
				})}

			<Spacer customHeight="8rem" />
		</div>
	);
};
export default HelpCenterPage;
